import { useEffect, useState, type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth.store';
import { createQueryClient } from './query-client';

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);

  // Cached data belongs to the signed-in user: drop it the moment the session ends, so the next
  // user (possibly of the other portal) never sees it.
  useEffect(
    () =>
      useAuthStore.subscribe((state, prev) => {
        if (prev.status === 'authenticated' && state.status !== 'authenticated')
          queryClient.clear();
      }),
    [queryClient],
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
